import React, { useState, useContext, useEffect } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Create from './Create'
import { setBodyHeight, logAlert } from '../../lib/easybake'
import { decodeToken, getOrgs } from '../../lib/consoleApi'

export default function AwsMp () {
    const { ut, act, page, dispatch } = useContext(EasybakeContext)
    const [ awsCustomerId, setAwsCustomerId ] = useState(null)
    const [ awsProdCode, setAwsProdCode ] = useState(null)

    useEffect(() => {
        setBodyHeight()
        if (ut) {
            getUserOrgs()
            async function fetchMyAPI() {
                const dToken = await decodeToken(act)
                if (dToken.customer_id && dToken.product_code) {
                    setAwsCustomerId(dToken.customer_id)
                    setAwsProdCode(dToken.product_code)
                }
            }
            if (act) {
                fetchMyAPI()
            }
        }
    }, [ut, act])

    async function getUserOrgs() {
        try {
            const orgs = await getOrgs(ut)
            if (orgs && orgs.error) {
                throw new Error(orgs.error)
            } else {
                dispatch({ type: 'set-userOrgs', payload: { userOrgs: orgs.response } })
            }
        } catch(e) {
            logAlert(e)
            analytics.sendEventName('click', `${page}:getuserorgs:error`)
        }
    }

    if (act) {
        return <Create referrer={ {
            awsCustomerId: awsCustomerId,
            awsProdCode: awsProdCode
        }}/>
    } else {
        return <Create />
    }
}
